import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-946e6f6e")
const _hoisted_1 = {
  key: 0,
  class: "container mx-auto"
}
const _hoisted_2 = { class: "claim-container flex flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_4 = { class: "flex py-5" }
const _hoisted_5 = { class: "mr-4 mt-3" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Total value", -1)
const _hoisted_8 = { class: "flex items-center justify-center" }
const _hoisted_9 = { class: "flex py-5" }
const _hoisted_10 = { class: "mr-4 mt-3" }
const _hoisted_11 = { class: "title claim-amount" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "Total Rewards", -1)
const _hoisted_13 = {
  key: 0,
  class: "break"
}
const _hoisted_14 = { class: "pools flex flex-1 flex-col" }
const _hoisted_15 = { class: "pool-header" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h-4" }, "My positions", -1)
const _hoisted_17 = {
  key: 0,
  class: "h-4"
}
const _hoisted_18 = {
  key: 1,
  class: "h-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "h-4" }, "To claim", -1)
const _hoisted_20 = {
  key: 2,
  class: "h-4"
}
const _hoisted_21 = { class: "flex-none" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "singlestake-tokenpill" }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center self-center"
}
const _hoisted_25 = {
  key: 1,
  class: "flex items-center self-center"
}
const _hoisted_26 = {
  key: 2,
  class: "flex items-center self-center claim-amount"
}
const _hoisted_27 = { class: "flex items-center self-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Claim ")
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "mt-5 w-full text-center"
}
const _hoisted_32 = {
  key: 2,
  class: "mt-[26px] flex items-center self-center"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Claim All ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletNewIcon = _resolveComponent("WalletNewIcon")!
  const _component_DollarCoinsStackedIcon = _resolveComponent("DollarCoinsStackedIcon")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_TokenPills = _resolveComponent("TokenPills")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MyPoolInvsetmentFiat = _resolveComponent("MyPoolInvsetmentFiat")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!

  return (_ctx.account != '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["stats grid", { 'flex-none': _ctx.isDesktop, 'flex-1': _ctx.isMobile }])
          }, [
            (_ctx.totalPoolFiatValue > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_WalletNewIcon)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.fNum2(Number(_ctx.totalPoolFiatValue), _ctx.FNumFormats.fiat)), 1),
                      _hoisted_7
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DollarCoinsStackedIcon)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.totalClaims.toLocaleString('en-US')), 1),
                  _hoisted_12
                ])
              ])
            ])
          ], 2),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.claims.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["grid-table", { mobile: _ctx.isMobile }])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Tokens"))
                      : _createCommentVNode("", true),
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "$ Tokens value"))
                      : _createCommentVNode("", true),
                    _hoisted_19,
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["border", { mobile: _ctx.isMobile }])
                  }, null, 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (claim, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "pool-row my-[18px] flex w-full items-center"
                    }, [
                      _createVNode(_component_router_link, {
                        to: _ctx.getRooterLink(claim),
                        class: "flex flex-1 items-center"
                      }, {
                        default: _withCtx(() => [
                          (claim.pool!=undefined)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_BalAssetSet, {
                                    size: 36,
                                    addresses: _ctx.iconAddresses(claim),
                                    width: 60
                                  }, null, 8, ["addresses"])
                                ]),
                                _createVNode(_component_TokenPills, {
                                  class: "token-pill ml-4",
                                  tokens: _ctx.orderedPoolTokens(claim.pool.poolType, claim.pool.address, claim.pool.tokens),
                                  isStablePool: false,
                                  selectedTokens: [],
                                  showWeight: false
                                }, null, 8, ["tokens"])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("img", {
                                  class: "singlestake-logo",
                                  src: _ctx.getSingleStakeLogo(claim)
                                }, null, 8, _hoisted_22),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getSingleStakeName(claim)), 1)
                              ], 64))
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (_ctx.isDesktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(claim.stakedBalance), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isDesktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_MyPoolInvsetmentFiat, {
                              pool: claim.pool,
                              tokens: claim.stakedBalance,
                              ref: "poolTotalFiatValues"
                            }, null, 8, ["pool", "tokens"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isDesktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(claim.xpolarToClaim), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.isDesktop)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "claim-btn flex items-center",
                              onClick: ($event: any) => (_ctx.claimXpolar(claim))
                            }, [
                              _hoisted_29,
                              _createVNode(_component_ArrowRightIcon, { class: "ml-3" })
                            ], 8, _hoisted_28))
                          : _createCommentVNode("", true),
                        (_ctx.isMobile)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "claim-btn-mobile w-full items-center",
                              onClick: ($event: any) => (_ctx.claimXpolar(claim))
                            }, _toDisplayString(claim.xpolarToClaim) + " | Claim ", 9, _hoisted_30))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, "Loading...")),
            (_ctx.claims.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "claim-btn-all flex items-center justify-center",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.claimXpolarAll()))
                  }, [
                    _hoisted_33,
                    _createVNode(_component_ArrowRightIcon, { class: "ml-3" })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}